/* eslint-disable react/jsx-boolean-value */
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Select, InputLabel, FormControl, MenuItem } from '@material-ui/core';
import useReactHookFormStyles from '../../../../custom-components/form-components/ReactHookForm.styles';

const BooleanSelect = ({ name, props: { label, defaultValue, optionMap, variant, required, ...rest } }) => {
    const classes = useReactHookFormStyles();
    const { control } = useFormContext();

    const getCustomOptionMap = (options) => {
        const defaultOptions = new Set(['true', 'false', 'empty']);
        const customOptions = {};

        Object.keys(options).forEach((key) => {
            if (!defaultOptions.has(key)) {
                customOptions[key] = options[key];
            }
        });

        return Object.entries(customOptions).map(([key, value]) => <MenuItem value={key}>{value}</MenuItem>);
    };

    return (
        <FormControl variant="outlined" className={classes.formController} required={required}>
            <Controller
                name={name}
                control={control}
                defaultValue={defaultValue}
                render={({ field: { onChange, value } }) => {
                    return (
                        <>
                            <InputLabel id="demo-simple-select-outlined-label">{label}</InputLabel>
                            <Select labelId="demo-simple-select-outlined-label" id="demo-simple-select-outlined" label={label} value={value} onChange={onChange}>
                                {!required && <MenuItem value={null}>{optionMap.empty ?? 'None'}</MenuItem>}
                                <MenuItem value={true}>{optionMap.true}</MenuItem>
                                <MenuItem value={false}>{optionMap.false}</MenuItem>
                                {getCustomOptionMap(optionMap)}
                            </Select>
                        </>
                    );
                }}
            />
        </FormControl>
    );
};

export default React.memo(BooleanSelect);
